import { useEffect } from "react";
import { Link, useRouteError } from "react-router-dom";
import { queryClient, zServerAppError } from "../bootstrapping/InitReactQuery";
import { Helmet } from "react-helmet-async";
import { Container } from "@mui/material";
import GoToDashboardButton from "./GoToDashboardButton";
import { AxiosError } from "axios";
import { reportRouteError } from "../bootstrapping/sentry";

export default function ErrorPage() {
  const error = useRouteError();
  console.error('ErrorPage:', error);

  // DBS-350: route errors used to reach only the console
  useEffect(() => { reportRouteError(error) }, [error]);

  const isProfileJwtExpired = (() => {
    if (error instanceof AxiosError && error.response?.data) {
      const parsedError = zServerAppError.safeParse(error.response.data)
      if (!parsedError.success) return false;
      return parsedError.data.error.type === 'errProfileJwtExpired';
    }
    return false;
  })()

  const parsedError = zServerAppError.safeParse(error);

  useEffect(() => {
    if (isProfileJwtExpired) {
      // Wipe everything out, including the profile JWT loader in QueryKey 'getMyProfile'
      console.warn('Profile JWT expired, invalidating all queries...');
      queryClient.invalidateQueries()
    }
  }, [isProfileJwtExpired]);

  return <>
    <Helmet>
      <title>Error Page</title>
    </Helmet>
    <Container component="main" maxWidth="xs">
      <div id="error-page">
        {isProfileJwtExpired
          ? <>
            <h1>Your access has Timed Out</h1>
            <p>To keep your data secure, we have to refresh your login tokens. You can continue from the dashboard.</p>
            <GoToDashboardButton />
          </>
          : <>
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred: <em>{parsedError.success && parsedError.data.error.type}</em>.</p>
            {parsedError.success && (
              <p>
                <i>{parsedError.data.error.message}</i>
              </p>
            )}
            <p>
              Return to the <Link to='/'>homepage</Link>
            </p>
          </>
        }
      </div>
    </Container>
  </>;
}
